import { Button, XStack } from 'tamagui'
import { HeroIcon } from '@components/HeroIcon'

interface IFloatingExpandButtonProps {
  onPress: () => void
  bottom?: number
  right?: number
  testID?: string
}

export function FloatingExpandButton({
  onPress,
  bottom = 16,
  right = 16,
  testID = 'floating-expand-button',
}: IFloatingExpandButtonProps) {
  return (
    <XStack
      position="absolute"
      bottom={bottom}
      right={right}
      backgroundColor="$bg-page"
      opacity={0.9}
      borderRadius="$border-radius-md"
      padding="$spacing-inset-quarck"
      zIndex={10}
      testID={testID}
    >
      <Button
        bg="transparent"
        onPress={onPress}
        padding="$spacing-inset-quarck"
        w={30}
        h={30}
        icon={
          <HeroIcon
            icon={['fal', 'expand']}
            size={20}
            color="$icon-secondary"
          />
        }
      />
    </XStack>
  )
}
